<template>
  <b-container>
    <div class="text-left my-4">
      <div class="d-flex">
        <div class="col">
          <h1 class="mb-4 main-header">
            Forrástérkép
          </h1>
          <p class="max-w-p main-desc">
            Tudja meg gyorsan és egyszerűen, hogy céges és pénzügyi adatai alapján a céljaihoz mely támogatott
            finanszírozási eszközöket tudja igénybe venni.
          </p>
        </div>

        <div class="col d-none d-sm-block">
          <img src="../../assets/img/fundMap/fund-map-hero.png" alt="fund-map-hero" class="hero-image" />
        </div>
      </div>
    </div>

    <div>
      <h2 class="my-4">
        Válassza ki a cégét a Forrástérkép használatához
      </h2>

      <template v-if="userCompanyOptions.length && isSearchCompany && isAuthenticated" class="my-4">
        <b-row col="12" class="mb-2">
          <b-col>
            <div class="select-company-wrapper rounded">
              <ifka-vp-select-company />
            </div>
          </b-col>
        </b-row>
      </template>

      <template v-if="userSoleProprietorshipOptions.length && !isSearchCompany && isAuthenticated">
        <b-row col="12" class="mb-2">
          <b-col>
            <div class="select-company-wrapper rounded">
              <SelectSoleProprietorship />
            </div>
          </b-col>
        </b-row>
      </template>

      <div class="d-flex justify-content-center my-4">
        <p class="max-w-p">
          Vagy adjon hozzá még egy társas vállalkozást a profiljához.
        </p>
      </div>
    </div>

    <ifka-vp-search-company hideCompanyTypeToggle="true" />

    <div class="mt-5">
      <router-link to="/fund-map/create-company">Új vállalkozást tervezek</router-link>
    </div>

    <div v-if="!isAuthenticated" class="login-box bg-color-lightblue p-2 mt-5 mb-4">
      <h2 class="my-4">Ha van már VALI fiókja, jelentkezzen be!</h2>

      <b-button variant="primary" @click="openLoginModal" class="login-button">Bejelentkezés</b-button>

      <b-row col="12" class="mt-4 mb-4 justify-content-md-center d-flex">
        <b-col sm="12" md="6" lg="4">
          Még nincs fiókom,
          <router-link :to="{ name: 'Register' }">regisztrálok</router-link>
        </b-col>
      </b-row>
    </div>

    <h2 class="text-left mt-5 my-4">
      Hogyan működik a Forrástérkép?
    </h2>
    <Explanation />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectCompany from '@/components/SelectCompany.vue'
import SelectSoleProprietorship from '@/components/SelectSoleProprietorship.vue'
import SearchCompany from '@/components/SearchCompany.vue'
import Explanation from './components/Explanation.vue'

export default {
  data: function() {
    return {}
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userCompanyOptions',
      'isSearchCompany',
      'userSoleProprietorshipOptions',
      'userCompanies',
      'selectedUserCompany'
    ])
  },
  components: {
    ifkaVpSearchCompany: SearchCompany,
    ifkaVpSelectCompany: SelectCompany,
    SelectSoleProprietorship,
    Explanation
  },
  methods: {
    nullifyCompanyAttributeObject(key) {
      this.$store.dispatch('nullifyCompanyAttributeObjectAction', key)
    },
    openLoginModal() {
      this.$root.$emit('bv::show::modal', 'login-modal')
    },
    openLoginRegistration() {
      this.$router.push('/register')
    }
  },
  async created() {
    this.nullifyCompanyAttributeObject({})
    this.$store.dispatch('resetFundMapStoreAction')

    if (this.isAuthenticated) {
      if (!this.userCompanyOptions.length) {
        const getParams = {}
        await this.$store.dispatch('getUserCompanies', getParams)
      }

      if (!this.userSoleProprietorshipOptions.length) {
        const getParams = {}
        await this.$store.dispatch('getUserSoleProprietorships', getParams)
      }

      if (this.userCompanies[0] && !this.selectedUserCompany) {
        this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
      }
    }
  }
}
</script>

<style scoped>
.current-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px !important;
  min-height: 56px !important;
  background-color: #00903c;
  color: #fff;
  border-radius: 50%;
  margin-right: 5px;
  font-weight: 700;
  font-size: 32px;
}

.max-w-p {
  max-width: 500px;
}

.login-box {
  max-width: 800px;
  margin: 0 auto;
  border-radius: 8px;
}

.hero-image {
  width: 100%;
  margin-left: 30px;
}

.main-header {
  font-weight: 800;
  font-size: 64px;
}

.main-desc {
  font-weight: 400;
  font-size: 16px;
}

.select-company-wrapper {
  background-color: #cce9d8;
  padding: 32px;
}

@media screen and (max-width: 768px) {
  .main-header {
    font-weight: 800;
    font-size: 40px;
  }
}
</style>
